var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingaporeFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_8989",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_8989)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V9H28V-3H-4Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.148926 3.375C-0.148926 -0.840559 3.49532 -1.15138 4.86865 -0.803711C4.86176 -0.801026 2.04248 0.299688 2.04248 3.375C2.04262 6.4459 4.85405 7.58395 4.86865 7.58984C3.44028 8.38484 -0.148795 7.59036 -0.148926 3.375ZM6.78955 5.37207H7.70264L7.02881 6.12598L7.23193 7.08105L6.40283 6.5918L5.59229 7.08105L5.77783 6.12598L5.10303 5.41113L6.01611 5.37207L6.40283 4.48047L6.78955 5.37207ZM9.73584 5.31738H10.6489L9.9751 6.07129L10.1782 7.02637L9.34912 6.53711L8.53857 7.02637L8.72412 6.07129L8.04932 5.35645L8.9624 5.31738L9.34912 4.42578L9.73584 5.31738ZM5.75635 3.00391H6.66943L5.99561 3.75781L6.19873 4.71289L5.36963 4.22363L4.55908 4.71289L4.74463 3.75781L4.06982 3.04297L4.98291 3.00391L5.36963 2.1123L5.75635 3.00391ZM11.1147 2.95996H12.0278L11.354 3.71387L11.5571 4.66895L10.728 4.17969L9.91748 4.66895L10.103 3.71387L9.42822 2.99902L10.3413 2.95996L10.728 2.06836L11.1147 2.95996ZM8.48486 1.06152H9.39697L8.72412 1.81543L8.92627 2.77051L8.09814 2.28125L7.2876 2.77051L7.47217 1.81543L6.79736 1.10059L7.71143 1.06152L8.09814 0.169922L8.48486 1.06152Z",
    fill: "#F1F9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingaporeFlagIcon);
export default __webpack_public_path__ + "static/media/singaporeFlagIcon.914b6bfa49f11986ab61b68b1cd962cf.svg";
export { ForwardRef as ReactComponent };